import type { ReactNode } from 'react';
import { Box, Flex, type FlexProps, Text } from '@/ui';

type Props = Omit<FlexProps, 'title'> & {
  /** Plan name heading. Omit for cards that lead with other content. */
  title?: string;
  badge?: ReactNode;
  /** Right-aligned detail on the header row, e.g. a capacity summary. */
  meta?: ReactNode;
};

// The bordered plan surface used by the personal panel and both workspace
// panels: an optional "<plan name> <badge> … <meta>" header over freely
// composed body content.
export const PlanCard = ({
  title,
  badge,
  meta,
  children,
  ...flexProps
}: Props) => (
  <Flex
    borderColor="gray.200"
    borderRadius="ah-xl"
    borderWidth="1px"
    direction="column"
    gap="4"
    p="6"
    {...flexProps}
  >
    {(title || meta) && (
      <Flex align="center" gap="3">
        {title && (
          <Text fontSize="2xl" fontWeight="medium" lineHeight="short">
            {title}
          </Text>
        )}
        {badge}
        {meta && <Box ml="auto">{meta}</Box>}
      </Flex>
    )}
    {children}
  </Flex>
);
